import moment from "moment";
import { NUMERIC_DATA_TYPES, DATETIME_FORMATTER, DATE_FORMATTER, DATEONLY_FORMATTER } from "../../constants/commonConstants";
import { fetchApi } from "../../services/apiService";
import { makeStyles } from "@mui/styles";

export const getRevDate = (date) => {
    var val = date.split(",")[0];
    return (
        val.split("/")[2] +
        "-" +
        (val.split("/")[0] < 10 ? "0" + val.split("/")[0] : val.split("/")[0]) +
        "-" +
        (val.split("/")[1] < 10 ? "0" + val.split("/")[1] : val.split("/")[1])
    );
};

export const getDate = (date) => {
    var dt = date.toString().split(" ");
    return (
        dt[0] +
        ", " +
        dt[2] +
        "-" +
        dt[1] +
        "-" +
        dt[3].substr(2) +
        " " +
        dt[4].substr(0, 5)
    );
};

export const hasAccess = (rights, code, adminType) => {
    if (adminType === 1 || adminType === 2) { return true }
    if (typeof code === 'string') {
        code = parseInt(code);
    }
    return rights.findIndex((rc) => code === rc) >= 0 ? true : false;
}

export const NumberFormatter = (value, decimal) => {
    if (value === '' || value === null || value === undefined || isNaN(value)) {
        return '';
    }
    return Number(parseFloat(value).toFixed(decimal || 2));
};

export const NumberFormatterToLocalString = (value, decimal) => {
    return parseFloat(parseFloat(value).toFixed(decimal || 2)).toLocaleString(
        "en-IN",
        {
            useGrouping: true,
            minimumFractionDigits: decimal || 2
        }
    );
};

export const jsPdfHeaderFooter = (data, reportTitle, userData, totalPagesExp) => {
    const doc = data.doc;
    doc.setTextColor(40);
    doc.addImage('/images/logo-66.png', 'JPEG', data.settings.margin.left, 5, 10, 10)
    doc.setFontSize(12);
    doc.setTextColor(16, 79, 162);
    doc.text(reportTitle, data.settings.margin.left + 12, 12);
    doc.setFontSize(10).setFont(undefined, 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('Company Name : ', data.settings.margin.left + 180, 12);

    doc.setFontSize(9).setFont(undefined, 'normal');
    doc.text(userData.companyName, data.settings.margin.left + 210, 12);

    // Footer
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    doc.line(0, pageHeight - 7, pageWidth, pageHeight - 7);
    var str = 'Page : ' + doc.internal.getNumberOfPages()
    // Total page number plugin only available in jspdf v1.0+ 
    if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
    }
    doc.setFontSize(10);
    doc.text(str, data.settings.margin.left + 260, pageHeight - 2);
    doc.setFont('Nirmala', 'normal');
    doc.text(`Report By : ${userData.userFullName} [ ${userData.branchName} ]`, data.settings.margin.left, pageHeight - 2);
    doc.text(`Report Time : ${moment(new Date()).format("DD MMM YYYY, ddd, HH:mm")}`, data.settings.margin.left + 150, pageHeight - 2);
}

export const jsPdfHeaderFooterPortrait = (data, reportTitle, userData, totalPagesExp) => {
    const doc = data.doc;
    doc.setTextColor(40);
    doc.addImage('/images/logo-66.png', 'JPEG', data.settings.margin.left, 5, 14, 14)
    doc.setFontSize(12);
    doc.setTextColor(16, 79, 162);
    doc.text(reportTitle, data.settings.margin.left + 16, 12);
    doc.setFontSize(10).setFont(undefined, 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('Company Name : ', data.settings.margin.left + 16, 18);

    doc.setFontSize(9).setFont(undefined, 'normal');
    doc.text(userData.companyName, data.settings.margin.left + 46, 18);

    // Footer
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    doc.line(0, pageHeight - 7, pageWidth, pageHeight - 7);
    var str = 'Page : ' + doc.internal.getNumberOfPages()
    // Total page number plugin only available in jspdf v1.0+ 
    if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
    }
    doc.setFontSize(10);
    doc.text(str, data.settings.margin.left + 97, pageHeight - 9);
    doc.setFont('Nirmala', 'normal');
    doc.text(`Report By : ${userData.userFullName} [ ${userData.branchName} ]`, data.settings.margin.left, pageHeight - 2);
    doc.text(`Date : ${moment(new Date()).format("DD MMM YYYY, ddd, HH:mm")}`, data.settings.margin.left + 153, pageHeight - 2);
}


export const jsPdfWillDrawCellCallback = (data) => {
    const pdoc = data.doc;
    if (!data.row.raw.isDataRow && data.row.section !== 'head') {
        pdoc.setFont('Nirmala', 'bold');
        pdoc.setFontSize("8");
        if (data.row.raw.rowColor) {
            const rowColorArr = data.row.raw.rowColor.rgb || data.row.raw.rowColor.rbg;
            pdoc.setFillColor(rowColorArr[0], rowColorArr[1], rowColorArr[2]);
        }
        if (data.row.raw.textColor) {
            const textColorArr = data.row.raw.textColor.rbg || data.row.raw.textColor.rgb;
            pdoc.setTextColor(textColorArr[0], textColorArr[1], textColorArr[2]);
        }
        if (!data.row.raw.isSubHeadingRow && !data.row.raw.isChildRow) {
            if (data.column.raw.xlCol.dataType === 'quantity') {
                data.cell.text[0] = NumberFormatterToLocalString(data.cell.text[0], 3);

            } else if (data.column.raw.xlCol.dataType === 'currency') {
                data.cell.text[0] = data.cell.text[0] !== '' ? NumberFormatterToLocalString(data.cell.text[0], 2) : '';

            } else if (data.column.raw.xlCol.dataType === 'dateTime') {
                data.cell.text[0] = DateTimeFormatter(data.cell.text[0]);
            } else if (data.column.raw.xlCol.dataType === 'date') {
                data.cell.text[0] = DateFormatter(data.cell.text[0]);
            }
        } else if (data.row.raw.isChildRow) {
            pdoc.setFont('Nirmala', 'normal');
        }
    } else if (data.row.raw.isDataRow) {
        if (data.column.raw.xlCol.dataType === 'quantity') {
            data.cell.text[0] = NumberFormatterToLocalString(data.cell.text[0], 3);

        } else if (data.column.raw.xlCol.dataType === 'currency') {
            data.cell.text[0] = NumberFormatterToLocalString(data.cell.text[0], 2);

        }
    }
}

export const jsPdfDidParseCellCallback = (data, pdfColumns, itemValueColumns) => {
    if (!data.row.raw.isDataRow && data.row.section !== 'head') {
        if (data.row.raw.isSubHeadingRow) {
            if (Array.isArray(data?.row?.raw?.subHeadingData)) {
                let prevColSpan = 0;
                data.row.raw.subHeadingData.forEach((subHeadingObj, index) => {
                    let cellValue = '';
                    if (subHeadingObj.hasOwnProperty('caption'))
                        cellValue += subHeadingObj.caption;
                    if (subHeadingObj.hasOwnProperty('value'))
                        cellValue += ' ' + subHeadingObj.value;
                    const startColSpanIndex = prevColSpan;
                    data.row.cells[startColSpanIndex].text = cellValue;
                    data.row.cells[startColSpanIndex].colSpan = subHeadingObj.colSpan;
                    data.row.cells[startColSpanIndex].styles.halign = "left";
                    data.row.cells[startColSpanIndex].styles.font = "Nirmala";
                    data.row.cells[startColSpanIndex].styles.fontSize = "9";
                    if (subHeadingObj.hasOwnProperty('align')) {
                        data.row.cells[startColSpanIndex].styles.halign = subHeadingObj.align;
                    }
                    prevColSpan = startColSpanIndex + subHeadingObj.colSpan;
                });
            }
        } else if (data.row.raw.isTotalRow) {
            data.row.cells[0].colSpan = data.row.raw?.colSpan;
            data.row.cells[0].text = [data.row.raw?.totalCaption || 'Total'];
            data.row.cells[0].styles.halign = 'right';
        } else if (data.row.raw.isNoDataRow) {
            data.row.cells[0].colSpan = pdfColumns.length;
            data.row.cells[0].text = [data.row.raw?.rowCaption || 'No Records'];
            data.row.cells[0].styles.textColor = [255, 0, 0];
            data.row.cells[0].styles.halign = 'center';
        } else if (data.row.raw.isChildRow) {
            data.row.cells[1].colSpan = data.row.raw.colSpan;
            data.row.cells[1].text = [data.row.raw?.text || ''];
            data.row.cells[1].styles.halign = 'left';
        }
    } else if (data.row.section === 'head') {
        if (NUMERIC_DATA_TYPES.indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = "right";
        } else {
            data.cell.styles.halign = "left";
        }
    } else if (data.row.raw.isDataRow && data.row.raw.rowSpan && data.row.raw.rowSpan > 1) {
        data.row.cells[0].rowSpan = data.row.raw.rowSpan;
        data.row.cells[1].styles.valign = 'middle';
    }
}

export const DateTimeFormatter = (date) => {
    return moment(date).format(DATETIME_FORMATTER);
}


export const DateFormatter = (date) => {
    if (date !== '') {
        return moment(date).format(DATE_FORMATTER);
    }
}

export const DateOnlyFormatter = (date) => {
     if (date !== '') {
    return moment(date).format(DATEONLY_FORMATTER);
     }
}

export const calculateDateDifference = (startDate, endDate, returnUnits = ['years', 'months', 'days', 'hours', 'minutes', 'seconds']) => {
    const start = moment(startDate);
    const end = moment(endDate);
    const result = {};

    returnUnits.forEach((unit) => {
        result[unit] = end.diff(start, unit);
        start.add(result[unit], unit); // Update start to calculate the next unit difference
    });

    return result;
}

export const focusElement = (elementID) => {
    elementID && document.getElementById(elementID) && document.getElementById(elementID).focus()
}

export const clickElement = (elementID) => {
    elementID && document.getElementById(elementID) && document.getElementById(elementID).click()
}

export const btnEnterFunction = (e, nextId, prevId) => {
    if (e.key === 'ArrowLeft') {
        focusElement(prevId)
    }
    if (e.key === 'ArrowRight') {
        focusElement(nextId)
    }
}

export const enterFunctionTwo = (e, nextId, prevId, lastFieldId, buttonId) => {
    if (e.key === 'Escape') {
        focusElement(prevId)
    }
    if (e.key === 'Enter') {
        if (nextId === buttonId && document.getElementById(lastFieldId) === document.activeElement) {
            focusElement(buttonId)
        } else {
            focusElement(nextId)
        }
    }
};

export const enterFunction = (e, nextId, prevId, lastFieldId, buttonId) => {
    if (e.key === 'Escape') {
        focusElement(prevId) || clickElement(prevId)
    }
    if (e.key === 'Enter') {
        if (nextId === buttonId && document.getElementById(lastFieldId) === document.activeElement) {
            focusElement(buttonId)
        } else {
            focusElement(nextId) || clickElement(nextId)
        }
    }
};


export const isEmpty = (obj) => {
    return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
}

const memoisedPost = () => {
    const cache = new Map()
    return async (...args) => {
        const selector = JSON.stringify(args)
        const forceRefresh = args[args.length - 1]; // Last argument indicates whether to force refresh
        if (forceRefresh && cache.has(selector)) {
            cache.delete(selector); // Remove cached response if force refresh is true
        }
        if (cache.has(selector)) {
            return cache.get(selector)
        }
        let url = args[0]
        const postData = args[1]
        const response = await fetchApi(url, postData, args[2])
        cache.set(selector, response);
        return response;
    }
}
export const PostRequestCached = memoisedPost();


export const enterFunctionV2 = (e, nextId, prevId, lastFieldId, buttonId) => {
    if (e.key === 'Escape') {
        focusElement(prevId);
    }
    if (e.key === 'Enter') {
        focusElement(nextId);
    }
};

export const handlekeyDown = (e, prevId, nextId, currentId, siblingId, rowIndex) => {
    if (e.key === 'Enter') {
        focusElement(nextId);
    } else if (e.key === 'Escape') {
        focusElement(prevId);
    } else if (e.key === ' ') {
        clickElement(currentId);
    } else if (currentId === `editBtn-${rowIndex}` && e.key === "ArrowRight") {
        focusElement(siblingId);
    } else if (currentId === `deleteBtn-${rowIndex}` && e.key === "ArrowLeft") {
        focusElement(siblingId);
    } else if (currentId === `cancelBtn-${rowIndex}` && e.key === "ArrowLeft") {
        focusElement(siblingId);
    }
}

export const buttonsFocus = (e, func, nextId, prevId, type, nextId2) => {
    if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        if (type === "EX") {
            func()
            focusElement(nextId2)
        } else {
            func()
        }
    }
    enterFunctionV2(e, nextId, prevId)
}
export const  isKeyValidForPattern = (pattern, key) =>{
    return pattern.test(key)
}

export const isControlKey = (key) => {
    return key === 'Backspace' || key === 'Delete' || key === 'Tab' || key === 'ArrowLeft' || key === 'ArrowRight' || key === 'Enter'
}

export const handleDoubleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
}

export const useStyles = makeStyles({
    root: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "6px",
            color: "#000",
        },
        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            border: "1px solid",
            borderColor: "#A6A8AB",
        },
        "& .MuiInputLabel-outlined": {
            color: "#000",
            fontSize: "14px",
            fontWeight: "500",
            letterSpacing: ".03rem",
        },
        "& .MuiInputLabel-root": {
            top: "4px"
        },
        "& .MuiFormLabel-asterisk": {
            color: "#d32f2f"
        },
        "& .MuiFormLabel-filled": {
            color: "#666",
            fontSize: "15px",
            fontWeight: "500",
            letterSpacing: ".03rem",
        },
        "&:hover": {
            borderColor: "#A6A8AB",
        },
        "& .MuiInputLabel-outlined.Mui-focused": {
            color: "#0086ff",
            fontSize: "15px",
        },
        "& input": {
            padding: "10px 14px",
            height: "1.6em",
        },
        "& input::placeholder": {
            color: "#666",
            fontSize: "12px",
        },
    },
});

export const roundToPosition = (num, decimalPlaces = 2) => {
    if (num === null || num === undefined || num === "") return 0;

    const n = Number(num);
    if (isNaN(n)) return 0;

    const factor = Math.pow(10, decimalPlaces);
    return Math.round(n * factor) / factor;
};


export const getAllErrors = (errors) => {
  const messages = [];

  const traverse = (errObj) => {
    if (!errObj) return;

    if (typeof errObj === 'string') {
      messages.push(errObj);
    } else if (Array.isArray(errObj)) {
      errObj.forEach((item) => traverse(item));
    } else if (typeof errObj === 'object') {
      Object.values(errObj).forEach((value) => traverse(value));
    }
  };

  traverse(errors);
  return messages;
};